import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ApiClientService, useApiClient } from 'libs.react_internal';
export const useActivityDetails = (params) => {
    const { get } = useApiClient(ApiClientService.LIBRARY);
    // Check if at least one parameter is provided
    const hasParams = useMemo(() => {
        if (!params) {
            return false;
        }
        return Object.values(params).some((value) => value !== undefined && value !== null);
    }, [params]);
    const fetchActivities = async () => {
        const queryParams = new URLSearchParams();
        // Add all non-undefined parameters to query string
        Object.entries(params || {}).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                queryParams.append(key, String(value));
            }
        });
        const queryString = queryParams.toString();
        const endpoint = `/v1/activity${queryString ? `?${queryString}` : ''}`;
        const { data } = await get(endpoint);
        return data;
    };
    const queryKey = ['activities', params];
    return useQuery({
        queryKey,
        queryFn: fetchActivities,
        enabled: hasParams, // Only run query if at least one parameter is provided
        refetchOnWindowFocus: false,
        retry: 1,
        // staleTime: 5 * 60 * 1000, // 5 minutes
    });
};
